export const OntopFileType = {
    'OBDA': 'obdaFile',
    'OWL': 'owlFile',
    'CONSTRAINT': 'constraintFile',
    'LENSES': 'lensesFile',
    'DB_METADATA': 'dbMetadataFile'
};
